export const skillsData = [
          {
                    id: 1,
                    category: "Frontend Development",
                    skills: [
                              {
                                        id: 1,
                                        name: "HTML",
                                        level: 'basic',
                              },
                              {
                                        id: 2,
                                        name: "CSS",
                                        level: 'intermediate',
                              },
                              {
                                        id: 3,
                                        name: "Bootstrap",
                                        level: 'intermediate',
                              },
                              {
                                        id: 4,
                                        name: "Tailwind",
                                        level: 'intermediate',
                              },
                              {
                                        id: 5,
                                        name: "Javascript",
                                        level: 'intermediate',
                              },
                              {
                                        id: 6,
                                        name: "React",
                                        level: 'intermediate',
                              },
                    ],
          },
          {
                    id: 2,
                    category: "Backend Development",
                    skills: [
                              {
                                        id: 1,
                                        name: "ExpressJS",
                                        level: 'intermediate',
                              },
                              {
                                        id: 2,
                                        name: "Firebase",
                                        level: 'intermediate',
                              },
                              {
                                        id: 3,
                                        name: "NodeJS",
                                        level: 'intermediate',
                              },
                              {
                                        id: 4,
                                        name: "Python",
                                        level: 'basic',
                              },
                              {
                                        id: 5,
                                        name: "MongoDB",
                                        level: 'intermediate',
                              },
                              {
                                        id: 6,
                                        name: "MySQL",
                                        level: 'basic',
                              },
                    ],
          },
];